import { Container, Divider, TestimonialCarousel } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import Engadget from './journalist-logo_engadget.svg'
import PCMag from './journalist-logo_pc-mag.svg'
import TC from './journalist-logo_tech-crunch.svg'
import Verge from './journalist-logo_the-verge.svg'

import css from './JournalistQuotes.module.css'

type QuotesWithoutDivider = {
    hasDivider?: never
    dividerLabel?: never
    dividerURL?: never
}

type QuotesDividerProps = {
    hasDivider: true
    dividerLabel: string
    dividerURL: string
}

type JournalistQuotes = QuotesWithoutDivider | QuotesDividerProps

export function JournalistQuotes({ hasDivider, dividerLabel, dividerURL }: JournalistQuotes) {
    const { t } = useTranslation(['slackalternative', 'common'])

    return (
        <Container className={css.journalistContainer}>
            {hasDivider ? <Divider className={css.topDivider} /> : null}
            <TestimonialCarousel
                id="journalistTestimonials"
                nextButtonLabel={t('next', { ns: 'common' })}
                previousButtonLabel={t('previous', { ns: 'common' })}
                testimonials={[
                    {
                        logo: (
                            <PCMag
                                width={48}
                                height={64}
                                aria-label="PC Mag"
                                className={css.journalistLogo}
                            />
                        ),
                        children: t('quotes.pcmag'),
                    },
                    {
                        logo: (
                            <Verge
                                width={150}
                                height={64}
                                aria-label="The Verge"
                                className={css.journalistLogo}
                            />
                        ),
                        children: t('quotes.theverge'),
                    },
                    {
                        logo: (
                            <TC
                                width={68}
                                height={64}
                                aria-label="TechCrunch"
                                className={css.journalistLogo}
                            />
                        ),
                        children: t('quotes.techcrunch'),
                    },
                    {
                        logo: (
                            <Engadget
                                width={142}
                                height={64}
                                aria-label="Engadget"
                                className={css.journalistLogo}
                            />
                        ),
                        children: t('quotes.engadget'),
                    },
                ]}
            />
            {hasDivider && dividerLabel && dividerURL ? (
                <Divider variant="button" href={dividerURL} className={css.bottomDivider}>
                    {dividerLabel}
                </Divider>
            ) : null}
        </Container>
    )
}
